import { Component, Input } from '@angular/core';

@Component({
  selector: 'acs-loading-spinner',
  templateUrl: './acs-loading-spinner.html',
  styleUrls: ['./acs-loading-spinner.scss']
})
export class AcsLoadingSpinnerComponent {
  @Input() size: 'small' | 'medium' | 'large' = 'medium';
  @Input() message: string = '';
  @Input() overlay: boolean = false;
}
